// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"f90bf829","787":"3bd41438"}[chunkId] + ".chunk.js";
};